<div class="modal-header ngbAutofocus">
    <h3 class="modal-title">Apply With PIN</h3>
</div>
<div class="modal-body">
    <div class="alert alert-danger" *ngIf="alert != null" close="closeAlert()">{{alert.msg}}</div>
    Please enter the PIN to coninue.
    <input type="text" class="form-control" [(ngModel)]="formData.PIN" style="margin-top:10px;" />
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="applyClicked()" [disabled]="formData.PIN == null || formData.PIN == ''">Apply</button>
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">Cancel</button>
</div>